import axios from "../util/axios";
import projectConfig from "@projectConfig";

const { hostCloud } = projectConfig.api;

let authValidationPromise: Promise<boolean> | null = null;

export const isLoggedIn = async (): Promise<boolean> => {
   if (authValidationPromise) {
      return authValidationPromise;
   }

   const token = localStorage.getItem("token");
   if (!token) {
      return false;
   }

   authValidationPromise = validateUserSession();

   try {
      return await authValidationPromise;
   } finally {
      authValidationPromise = null;
   }
};

const validateUserSession = async (): Promise<boolean> => {
   try {
      const response = await axios({
         method: "get",
         url: `${hostCloud}/users/user-info`,
         headers: {
            Accept: "*/*",
            "Content-Type": "application/json",
            "X-Auth-Validation": "true",
         },
      });

      if (response?.data && response.data.id) {
         return true;
      }

      return false;
   } catch (error: any) {
      if (error?.response?.status === 401 || error?.response?.status === 403) {
         return false;
      }

      console.warn("Auth validation failed due to network error:", error);
      return false;
   }
};

export const clearAuthValidation = () => {
   authValidationPromise = null;
};
